module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin3-70240cb8ddde63e96f7a330faaf8dd2f.jpg";